var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270 464.2",
    style: {
      enableBackground: "new 0 0 270 464.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83B3E2;}\n\t.st1{fill:#D0DE8E;}\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st3{fill:#F9DB00;}\n\t.st4{fill:#1F54B0;}\n\t.st5{fill:#D03632;}\n\t.st6{fill:#D1D1D1;}\n\t.st7{fill:none;stroke:#000000;stroke-width:0.57;stroke-linecap:round;}\n\t.st8{fill:#4C702B;}\n\t.st9{fill:#93B838;}\n\t.st10{fill:#B1CC40;}\n\t.st11{fill:#CAF741;}\n\t.st12{fill:#FEF7CE;}\n\t.st13{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wasser"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "92.3,251.6 93.4,15.4 90.3,15.3 89.1,251.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.5,66.7c0.3-0.5,0.9-0.9,1.5-1c0.9,0,1.8,0.3,2.1,3.5c0.8,9.1,6.6,3.2,7.3,12.7c0.7,10.5,3.4,5.2,3.6,11.7 c0.1,1.7,0.3,3.4,0.6,5.2c0.3,2.2,0.3,4.6-1.6,4.8c-3.8,0.4-2.9-6.7-5.2-8.4s-6.3,0.2-6.9-3.5c-0.5-3.1,3.5-3.4,3.1-8.2 c-0.2-2.8-3.8-2.9-3.7-5.3c0-1.8,1.5-2.2,2-2.9c1-1.7-1.2-4.6-2.7-4.6L125.5,66.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "89.2,254.2 90.7,451.3 93.9,451.3 92.3,254.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.7,71.6c-0.6,0-1.3-0.1-1.9-0.3c-1.5-0.5-2.9-1.3-4.1-2.4c-1-0.9-2.1-1.7-3.3-2.3c-1.9-0.9-8.2-1.1-13.5-1 v-2c4.2-0.1,11.7-0.1,14.4,1.2c1.4,0.7,2.7,1.5,3.8,2.6c0.9,0.9,2,1.6,3.3,2c1.2,0.3,2.4,0.2,3.5-0.3c1.6-0.6,3.3-0.9,5.1-0.9v2 c-1.5,0-3,0.2-4.4,0.8C116.7,71.4,115.7,71.6,114.7,71.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.7,440.9c-0.6,3.5-2,6.2-5.1,5.7c-3.6-0.5-3.9-3.5-3.3-7.1s2.1-6.1,5.2-5.7 C107.9,434.3,108.3,437.3,107.7,440.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.5,416.9c-5.2-0.7-6.1,4.1-6.6,5.8c-0.4,1.5-2.1,7.5,2.7,9.3c2.3,0.8,5.8-0.3,7.2-4.4 S123.9,417.6,118.5,416.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.4,377.2c-2.1-0.6-4.3,0.7-4.9,2.8c-1.4,3.8,0.9,8.7-1.3,10.4c-4.9,3.7-3.3,9.6,0.6,10 c7,0.7,3.2-8.3,5.8-11.8C133.9,384.1,134.5,378.2,130.4,377.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.1,441.3c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c0,0,0,0,0,0 C105.4,437.6,107.1,439.2,107.1,441.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.6,424c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c0,0,0,0,0,0 C118.9,420.3,120.6,422,120.6,424"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.4,394.3c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8 C127.7,390.6,129.4,392.2,129.4,394.3C129.4,394.3,129.4,394.3,129.4,394.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M133,381c0,2.1-1.7,3.8-3.7,3.8s-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.7-3.8c0,0,0,0,0,0 C131.3,377.2,133,378.9,133,381"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M168.9,455h-0.7l-112.8-1.3v-2.4l112.9,1.3c0.1,0,6.6,0.2,10-1.9c8-5,10-7.3,12.6-10.3 c0.6-0.7,1.2-1.4,1.9-2.1l1.8,1.6c-0.7,0.7-1.3,1.4-1.8,2.1c-2.6,3-4.9,5.7-13.2,10.8C176.3,454.8,170.8,455,168.9,455z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.1,
    y: 8.6,
    transform: "matrix(0.9789 -0.2045 0.2045 0.9789 0.4491 23.9989)",
    className: "st6",
    width: 84.5,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.9,
    y: 50.4,
    className: "st6",
    width: 13,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.7,
    y: 14,
    transform: "matrix(1 -1.396262e-03 1.396262e-03 1 -6.415003e-02 0.134)",
    className: "st6",
    width: 2.4,
    height: 64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3,54.5c-0.1,0-0.2,0-0.3-0.1l-1.2-1.1h-4.9l-1.1,1.1c-0.2,0.2-0.4,0.2-0.6,0c0,0,0,0,0,0c-0.2-0.1-0.2-0.4,0-0.6 c0,0,0,0,0,0l1.4-1.4h5.6l1.4,1.4c0.2,0.2,0.2,0.4,0,0.6c0,0,0,0,0,0C95.5,54.5,95.4,54.5,95.3,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2,50.7h-5.6l-1.4-1.4c-0.2-0.1-0.2-0.4-0.1-0.6c0.1-0.2,0.4-0.2,0.6-0.1c0,0,0.1,0,0.1,0.1l1.2,1.1h4.9l1.1-1.1 c0.2-0.2,0.4-0.2,0.6,0c0,0,0,0,0,0c0.2,0.1,0.2,0.4,0,0.6c0,0,0,0,0,0L94.2,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M94.4,255.8c-0.1,0-0.2,0-0.3-0.1l-1.2-1.1H88l-1.1,1.1c-0.1,0.2-0.4,0.2-0.6,0c-0.2-0.1-0.2-0.4,0-0.6 c0,0,0,0,0,0l1.4-1.4h5.6l1.4,1.4c0.2,0.1,0.2,0.4,0,0.6c0,0,0,0,0,0C94.6,255.8,94.5,255.8,94.4,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.3,252h-5.6l-1.4-1.4c-0.2-0.2-0.2-0.4,0-0.6c0.2-0.2,0.4-0.2,0.6,0l0,0l1.2,1.1h5l1.1-1.1 c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6L93.3,252z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2,69.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.4,0-0.6c0,0,0,0,0,0l1.2-1.2v-4.9L93,61.3c-0.2-0.2-0.2-0.4,0-0.6 c0.2-0.2,0.4-0.2,0.6,0c0,0,0,0,0,0l1.4,1.3v5.6l-1.4,1.4C93.5,69.2,93.4,69.3,93.2,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4,69.2c-0.1,0-0.2,0-0.3-0.1l-1.4-1.4v-5.6l1.4-1.4c0.2-0.2,0.4-0.2,0.6,0c0.2,0.2,0.2,0.4,0,0.6l0,0l-1.2,1.2v4.9 l1.1,1.1c0.2,0.2,0.2,0.4,0,0.6C98.6,69.2,98.5,69.2,98.4,69.2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "120.7,72.3 122,71 122,65.7 120.7,64.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "126.6,64.6 125.3,65.9 125.3,71.1 126.6,72.4  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M116.7,15.7c-12.2,0-17.5,11.8-16.8,23.7s0.6,18,0.6,27.1c0,10.2-8.4-0.1-2.3,22c4.9,18,8.8,36.2,11.7,54.6 c1.6,11.4,6.3,40.2,8.4,55.4s6.1,13.7,6.9,22.8c1,11.7-3.6,14.6-3.3,25.8c0.1,4.1,2.2,10.3-1,25.8c-5.4,25.7-11.8,45.7-10.7,57.7 c0.7,7.2,6.7,14.6,14.2,15.6c23.7,3.3,20.8-12.9,25.8-32.8s9.2-33.8,11.3-40.2c2.6-7.7,6-15.9,7.9-21.4c1.7-5,2.2-13.2,2.2-22.8 c0-10-2.4-13.7-9.4-20.4c-6.3-6-11.2-28.1-12.2-34.3c-1.1-6.5-6.5-31-7.9-42.2c-1.4-10.5-5.3-29.4-7.2-35.2c-1.4-4.1-6.9-1-7.9-4.6 c-1-3.8,3.8-3.8,2.9-9.1c-0.3-2.1-3.5-2.6-3.6-4.6s4.2-4.4,4.2-4.4s-0.6-0.4-1.1-2.3c-0.3-0.9-0.4-1.7-0.4-2.6 c2-0.5,3.8-1.7,5.1-3.3c2.4-3.1,3.3-9.5,3.5-22.9C137.9,28,131.8,15.7,116.7,15.7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M124.8,90.4c0.5-6.2,3-9.6-10.6-15.4c-8.1-3.4-14.4,0.5-11.2,7.6c10.3,22.2,10.1,27.5,11.8,40.8 s7.9,40.1,8.8,50c0.6,6.6,2.2,24.4,6.9,31.8c2.9,4.6,7.9,6.2,10.1,13.4c1.5,5,2.9,9.6,1.7,12.4c-1.7,3.8-0.2,5.3,0.4,6 c3.8,4.8,2.1,7.7,0.9,12.2c-3.5,12.9-10.6,5.8-13.4,23.9c-1.8,12-5,25.6-7,34.9s-10.3,28.2,4.1,29.7c13,1.4,11.1-14.3,15.8-33.1 s9.2-31.7,11.8-40.2c6-19.4,8.7-26.9,6.2-38.1c-3.3-14.8-9.5-17.8-16.1-29.4c-3.4-6-5.4-31.1-7.6-42.7c-2.4-13.2-3.6-21.7-5.3-31.1 C128.6,104.7,124.4,95.5,124.8,90.4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M119.7,39.7c0.1-2.6-2.1-5.2-1.1-7.7c0.8-1.9,2.3-6.2-1.7-7.1c-7-1.6-4.8,4.7-5.8,7.9 c-0.7,2.2-2.6,2.4-4.1,4.5c-3.6,4.8,0.9,8.6,0.9,11.1c0,2.1-1,2.9-1,5.7c-0.1,4.7,4.3,6.7,7,6.6c0.8,0,5,0.4,6.6-6 c1.7-6.8-0.9-8.3-1.1-10.3S119.7,41.5,119.7,39.7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M114.6,36.2c-3.4-0.2-7.4,2.5-7.5,5.2c-0.1,3,1.9,4.3,2,6.8s-1,2.7-0.7,6.2c0.2,2.7,2.4,4.5,5.6,4.4 c2.5-0.1,4.2-1.7,5.1-5.8c1.3-6.4-2-5.8-1.3-11.3C118.2,37.7,116.2,36.3,114.6,36.2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M130.2,41.8c-0.1,1.1-0.7,1.8-0.8,2.9c0,0.9,0.3,1.1,0.3,2.3c0.1,1.7-0.8,2.5-2.3,1.6c-1.8-1.1-2.6-1-2.5-4.1 c0-2.7,0.1-5.2,3.1-4.9C129.2,39.6,130.2,40.6,130.2,41.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M124.1,51.8c-0.9,1-0.1,1.7-1.2,3c-1,1.1-2.7,1.9-1.7,3.6c1.3,2.1,4.2,1.1,5.4,0.3c1.4-1,1.2-2.6,1.4-3.4 c0.2-0.9,1.1-2.4-0.1-3.3C127.1,51.2,125.1,50.7,124.1,51.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M137.3,245.8c1.7-0.1,1.7,1.2,1.9,2.9c0.2,1.9,1.1,0.9,1.2,3.2c0.1,1.5-1.4,2.1-2.1,3.1 c-0.6,0.8-0.9,1.9-1.7,1.8s-2-2.1-3.2-1.6c-1.4,0.6-2.8,0.9-3-1.3c-0.2-2.6,1.8-1.5,3.7-3S135,246,137.3,245.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M129.6,232.9c-1.8-0.3-2.6,1.8-2.6,2.7c0.1,2.5,1.2,2.4,1.1,4.2c0,1-0.3,1.9-1,2.7c-1.6,2,0.2,4.4,1.8,4.2 c4.1-0.4,3.3-4.8,3.3-7.3S133.3,233.4,129.6,232.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M141.7,227c-0.3-1.6-1.9-2.7-3.5-2.4c-0.1,0-0.2,0-0.2,0.1c-2.4,0.6-2.6,4.8-2.4,6.2c0.4,2,1.6,4,1.5,5.8 c-0.1,2.2-0.1,4.1,1.2,5.1c1.9,1.5,2.9,2.7,4.9,1.4c1.8-1.2,0.6-3.7,0.1-4.9c-0.4-1-1.7-2.4-1.8-3.5 C140.9,230.6,142.7,230.7,141.7,227"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M132.3,215.4c-2.5-0.5-3.9,0.1-4.1,2.1c-0.1,1.3,0.7,1.6,0.2,5.6c-0.2,1.9,0,3.8,2.4,3.7c3.1,0,3.5-2.1,3.9-4 c0.5-1.5,0.7-3,0.6-4.5C135.1,216.7,133.9,215.5,132.3,215.4"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M93.7,105.7c1-1,1-2.6-0.1-3.6c-1-1-2.6-1-3.6,0.1c-0.3,0.3-0.5,0.7-0.6,1.1h-0.2c-1.4-0.1-2.6,1-2.7,2.4 s1,2.6,2.4,2.7c0.1,0,0.2,0,0.3,0c0.2,0,0.3,0,0.5,0c0.3,1.4,1.7,2.3,3,2s2.3-1.7,2-3C94.6,106.7,94.2,106.1,93.7,105.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M95,118.3c1-1,1.1-2.6,0.1-3.6c-0.5-0.5-1.2-0.8-1.9-0.8c-0.4,0-0.8,0.1-1.2,0.3c-0.7-1.3-2.2-1.7-3.5-1.1 c-1.3,0.7-1.7,2.2-1.1,3.5c0,0.1,0.1,0.2,0.2,0.3c-1.4,0.4-2.2,1.8-1.9,3.1c0.3,1.1,1.3,1.9,2.5,1.9c0.5,0,1-0.2,1.4-0.4 c0.4,0.3,0.9,0.4,1.4,0.4c0.3,0,0.7-0.1,1-0.2c0.5,1.3,1.9,2.1,3.3,1.6c1-0.4,1.7-1.3,1.7-2.4C97.2,119.5,96.2,118.5,95,118.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M164.6,63.1l-8.5-1.1l-5.7-6l1.2-9.8l-0.7-7.1l-7.1-6l-0.3,4.1c-1.1-0.9-2.7-0.7-3.6,0.4 c-0.9,1.1-0.7,2.7,0.4,3.6c0.5,0.4,1,0.6,1.6,0.6c0.5,0,0.9-0.1,1.3-0.4l-0.3,4.2l1.4,7.5l0.7,0.3c-0.7,0.5-1,1.2-1.1,2.1 c0,0.4,0.1,0.8,0.3,1.2c-1,0.7-1.4,2-0.9,3.1c-1.3,0.5-2.1,1.9-1.6,3.2c0.3,0.8,0.8,1.3,1.6,1.6c-0.2,0.3-0.4,0.7-0.4,1.1 c-0.2,0-0.4,0-0.6,0c-1.4,0-2.6,1.2-2.6,2.6c0,0,0,0,0,0c0,0.2,0,0.5,0.1,0.7c-1.4,0.2-2.4,1.6-2.1,3c0.2,0.9,0.8,1.7,1.7,2 c-0.2,0.4-0.4,0.8-0.4,1.3c0,0.7,0.3,1.4,0.8,1.9c-0.7,0.5-1.1,1.3-1.1,2.1c0,1.4,1.2,2.5,2.6,2.5c0.1,0,0.3,0,0.4,0l0,0 c0,0.8,0.4,1.5,1,2c-0.5,0.5-0.7,1.1-0.7,1.8c0,1.2,0.8,2.2,2,2.5c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.5,0.1,0.9,0.4,1.3 c-1.3,0.5-2,2-1.5,3.3c0.4,1.1,1.4,1.7,2.5,1.7c0.4,0,0.8-0.1,1.2-0.3c0.1,0.3,0.2,0.5,0.3,0.7c-1,0.4-1.7,1.3-1.7,2.4 c0,0.3,0.1,0.5,0.1,0.8c-0.1,0-0.2,0-0.3,0c-1.4,0-2.6,1.2-2.6,2.6s1.2,2.6,2.6,2.6c0.8,0,1.5-0.4,2-1c0.1,0.1,0.3,0.3,0.4,0.4 c-0.6,0.5-1,1.3-1,2.1c0,0.8,0.4,1.6,1.1,2.1c-1.1,0.3-1.9,1.3-1.9,2.5c0,0.1,0,0.2,0,0.3c-1.2,0.8-1.4,2.5-0.6,3.6 c0.3,0.5,0.8,0.8,1.4,1c-0.1,0.3-0.2,0.7-0.2,1c0,1.4,1.2,2.6,2.6,2.6l0,0h0.2c0,0.2,0,0.3,0,0.5c0,1.4,1.2,2.6,2.6,2.6 c0.5,0,1-0.2,1.4-0.4c1.1,0.9,2.7,0.7,3.5-0.4c0,0,0,0,0-0.1c1.1,0.9,2.7,0.8,3.6-0.3c0.4-0.5,0.6-1.1,0.6-1.7 c0-0.3-0.1-0.6-0.2-0.9l18.5-2.6l2.6-8.3L172,94.2l6.9-3.5l-8.3-11.7l11.2-7l-2.1-8.7c0,0-6-3.1-5.9-4L164.6,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M85.8,460.3c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.7-3.9,3.9-4C84,456.3,85.8,458.1,85.8,460.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.4,456.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C97.7,452.9,99.4,454.7,99.4,456.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M93.6,456.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C91.7,452.9,93.5,454.6,93.6,456.8C93.5,456.8,93.6,456.8,93.6,456.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.5,446.8c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9c0-2.2,1.7-4,3.9-4c0,0,0,0,0,0 C88.7,442.8,90.5,444.5,90.5,446.8C90.5,446.7,90.5,446.7,90.5,446.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.1,454c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9C87.3,450,89.1,451.8,89.1,454 C89.1,454,89.1,454,89.1,454"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M79.7,446.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C77.9,442.8,79.7,444.5,79.7,446.8C79.7,446.7,79.7,446.7,79.7,446.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.2,348.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C97.4,344.5,99.2,346.3,99.2,348.5C99.2,348.5,99.2,348.5,99.2,348.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.8,356.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C98,352.4,99.8,354.2,99.8,356.4C99.8,356.4,99.8,356.4,99.8,356.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.1,364.3c0,2.2-1.7,4-3.9,4.1s-4-1.7-4.1-3.9s1.7-4,3.9-4.1c0,0,0,0,0.1,0 C97.3,360.3,99.1,362.1,99.1,364.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.7,374.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9 C97.9,370.7,99.7,372.5,99.7,374.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.4,382.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C96.6,378.5,98.4,380.2,98.4,382.5 C98.4,382.4,98.4,382.4,98.4,382.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.8,391.9c0,2.2-1.7,4-3.9,4.1s-4-1.7-4.1-3.9s1.7-4,3.9-4.1c0,0,0,0,0.1,0C97,388,98.8,389.7,98.8,391.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100,401.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9C98.2,397.5,100,399.3,100,401.5 C100,401.5,100,401.5,100,401.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.4,410.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C97.6,406.4,99.4,408.1,99.4,410.4C99.4,410.3,99.4,410.4,99.4,410.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.7,420c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.7-3.9,3.9-4C95.9,416.1,97.7,417.8,97.7,420"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.5,429.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C97.7,425.6,99.5,427.3,99.5,429.5C99.5,429.5,99.5,429.5,99.5,429.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.2,439.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9c2.2,0,4,1.7,4,3.9 C99.3,439.3,99.3,439.4,99.2,439.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M191.1,446.2c0,2.2-1.7,4-4,4s-4-1.7-4-4c0-2.2,1.7-4,4-4c0,0,0.1,0,0.1,0C189.3,442.2,191.1,444,191.1,446.2 L191.1,446.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M200.1,452.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C198.3,448.4,200.1,450.1,200.1,452.4C200.1,452.3,200.1,452.4,200.1,452.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M193,450.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9C191.2,446.8,193,448.5,193,450.7 C193,450.7,193,450.7,193,450.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.8,439.9c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9s1.8-4,3.9-4c0,0,0,0,0,0C198,436,199.8,437.8,199.8,439.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M186.6,456.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C184.8,452.2,186.6,454,186.6,456.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.5,448.9c0,2.2-1.7,4-3.9,4.1c-2.2,0-4-1.7-4.1-3.9c0-2.2,1.7-4,3.9-4.1c0,0,0.1,0,0.1,0 C178.7,444.9,180.5,446.7,180.5,448.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126.6,450.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C124.8,446.2,126.6,447.9,126.6,450.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M112.9,450.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C111.1,446.6,112.9,448.3,112.9,450.5C112.9,450.5,112.9,450.5,112.9,450.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M116.3,456.8c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.7-3.9,3.9-4C114.5,452.9,116.3,454.7,116.3,456.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M122,459.2c0,2.2-1.7,4-3.9,4.1s-4-1.7-4.1-3.9s1.7-4,3.9-4.1c0,0,0,0,0.1,0C120.2,455.2,122,457,122,459.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M117.7,450.7c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C115.9,446.7,117.7,448.5,117.7,450.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M107.4,451.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C105.7,447.2,107.4,448.9,107.4,451.1C107.4,451.1,107.4,451.1,107.4,451.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.1,448.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C96.3,444.6,98.1,446.4,98.1,448.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M66.3,450.8c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C64.5,446.9,66.3,448.6,66.3,450.8 C66.3,450.8,66.3,450.8,66.3,450.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M68.5,458.9c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C66.8,454.9,68.5,456.7,68.5,458.9C68.5,458.9,68.5,458.9,68.5,458.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.3,345.4c0,2.2-1.7,4-3.9,4.1c-2.2,0-4-1.7-4.1-3.9c0-2.2,1.7-4,3.9-4.1c0,0,0.1,0,0.1,0 C179.5,341.5,181.2,343.2,181.3,345.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.2,360.3c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C151.4,356.4,153.2,358.1,153.2,360.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M143.2,380.2c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C141.4,376.2,143.2,378,143.2,380.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M151.1,379.1c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9S151.1,377,151.1,379.1L151.1,379.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M141.9,388.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C140.1,384.8,141.9,386.5,141.9,388.7C141.9,388.7,141.9,388.7,141.9,388.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.1,304.2c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4s1.8-3.9,4-3.9C98.3,300.3,100.1,302.1,100.1,304.2 C100.1,304.2,100.1,304.2,100.1,304.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.4,311.3c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S97.4,309.1,97.4,311.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.6,318.9c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.7-3.9,3.9-4C95.7,315,97.5,316.7,97.6,318.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.7,329.3c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C97.9,325.4,99.6,327.1,99.7,329.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100,338.5c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.7-3.9,3.9-4C98.2,334.5,99.9,336.3,100,338.5 L100,338.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M159.2,312.2c0,3.3-2.6,5.9-5.9,5.9c-3.3,0-5.9-2.6-5.9-5.9s2.6-5.9,5.9-5.9c0,0,0,0,0,0 C156.5,306.3,159.2,308.9,159.2,312.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.1,303c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C179.4,299,181.1,300.7,181.1,303 C181.1,302.9,181.1,303,181.1,303"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.9,311.9c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C198.2,308,199.9,309.8,199.9,311.9L199.9,311.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.7,303.8c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9C197.9,299.8,199.7,301.6,199.7,303.8 C199.7,303.8,199.7,303.8,199.7,303.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M190.1,304.2c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C188.3,300.2,190.1,302,190.1,304.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.1,324c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C179.4,320,181.1,321.7,181.1,324 C181.1,323.9,181.1,324,181.1,324"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.4,332.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C187.7,328.5,189.4,330.3,189.4,332.5C189.4,332.5,189.4,332.5,189.4,332.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.1,336.6c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C178.3,332.7,180.1,334.4,180.1,336.6L180.1,336.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M198.1,332.1c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S198.1,330.5,198.1,332.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M198.6,338.2c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C196.8,334.3,198.6,336,198.6,338.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.5,327c0,2.2-1.8,4-4,4c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c0,0,0,0,0,0C197.7,323,199.5,324.8,199.5,327 C199.5,327,199.5,327,199.5,327"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.2,319.9c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C197.5,316,199.2,317.7,199.2,319.9C199.2,319.9,199.2,319.9,199.2,319.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M196.4,346.1c0,2.2-1.7,4-3.9,4.1c-2.2,0-4-1.7-4.1-3.9s1.7-4,3.9-4.1c0,0,0,0,0.1,0 C194.5,342.2,196.3,343.9,196.4,346.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.3,342c0,2.2-1.7,4-4,4s-4-1.7-4-4c0-2.2,1.7-4,4-4c0,0,0.1,0,0.1,0C169.5,338,171.3,339.8,171.3,342 C171.3,342,171.3,342,171.3,342"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.7,295.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C96.9,291.8,98.7,293.6,98.7,295.8 C98.7,295.7,98.7,295.8,98.7,295.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.2,206c0,2.2-1.7,4-3.9,4.1c-2.2,0-4-1.7-4.1-3.9s1.7-4,3.9-4.1c0,0,0,0,0.1,0 C98.3,202.1,100.1,203.8,100.2,206"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.2,178.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9 C179.4,174.8,181.2,176.6,181.2,178.8C181.2,178.8,181.2,178.8,181.2,178.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M190.3,165.7c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9s1.7-4,3.9-4c0,0,0,0,0,0 C188.5,161.7,190.3,163.5,190.3,165.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.9,158c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C198.2,154,199.9,155.8,199.9,158 C200,157.9,200,157.9,199.9,158"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.9,147.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C188,143.5,189.8,145.2,189.9,147.4C189.9,147.4,189.9,147.4,189.9,147.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M200.2,135.1c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C198.4,131.1,200.2,132.9,200.2,135.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M152.7,152.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0 C151,148.7,152.7,150.5,152.7,152.7C152.7,152.7,152.7,152.7,152.7,152.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M152.1,158.1c0,3.3-2.7,5.9-5.9,5.9s-5.9-2.7-5.9-5.9c0-3.3,2.7-5.9,5.9-5.9l0,0 C149.5,152.2,152.1,154.8,152.1,158.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M149.9,139.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0 C148.1,135.8,149.9,137.6,149.9,139.8C149.9,139.8,149.9,139.8,149.9,139.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.2,213.8c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9s1.7-4,3.9-4c0,0,0,0,0,0 C98.3,209.8,100.1,211.6,100.2,213.8C100.1,213.8,100.2,213.8,100.2,213.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.5,222.3c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C96.8,218.3,98.5,220.1,98.5,222.3L98.5,222.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.1,230.4c0.2,2.2-1.5,4.1-3.7,4.3c-2.2,0.2-4.1-1.5-4.3-3.7s1.5-4.1,3.7-4.3c0.1,0,0.2,0,0.3,0 C96.2,226.6,98,228.3,98.1,230.4C98.1,230.4,98.1,230.4,98.1,230.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99,238.1c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C97.2,234.1,99,235.8,99,238.1 C99,238,99,238,99,238.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M115.6,288.7c0,2.2-1.7,4-3.9,4.1c-2.2,0-4-1.7-4.1-3.9s1.7-4,3.9-4.1c0,0,0.1,0,0.1,0 C113.8,284.8,115.6,286.5,115.6,288.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M113,280.5c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C111.2,276.5,113,278.3,113,280.5L113,280.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M120.3,277.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C118.6,273.7,120.3,275.5,120.3,277.6C120.3,277.6,120.3,277.6,120.3,277.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M117.7,270.1c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4s1.8-3.9,4-3.9C116,266.2,117.7,268,117.7,270.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M125,266.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9C123.2,262.7,125,264.4,125,266.6 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M112.6,264.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C110.7,260.2,112.5,262,112.6,264.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M121.3,258.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9 C119.5,254.6,121.3,256.4,121.3,258.6C121.3,258.6,121.3,258.6,121.3,258.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M115.6,253.2c0,2.2-1.8,4-3.9,4s-4-1.8-4-4c0-2.2,1.8-3.9,3.9-3.9h0C113.9,249.3,115.6,251,115.6,253.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M124.3,236.1c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C122.5,232.1,124.3,233.9,124.3,236.1L124.3,236.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M108.3,247.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C106.6,243.5,108.3,245.2,108.3,247.4C108.3,247.4,108.3,247.4,108.3,247.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.5,246c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C96.7,242,98.5,243.8,98.5,246 C98.5,246,98.5,246,98.5,246"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99,262.3c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9C97.2,258.4,99,260.2,99,262.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.2,267.8c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9c0-2.2,1.7-4,3.9-4c0,0,0,0,0,0 C98.3,263.9,100.1,265.6,100.2,267.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M101.1,286.6c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C99.3,282.7,101.1,284.4,101.1,286.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99,277.2c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C97.2,273.2,99,275,99,277.2 C99,277.2,99,277.2,99,277.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.1,196c0,2.2-1.7,4-3.9,4.1c-2.2,0-4-1.7-4.1-3.9s1.7-4,3.9-4.1c0,0,0,0,0.1,0 C96.3,192.1,98.1,193.8,98.1,196"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.1,186.1c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S98.1,183.9,98.1,186.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.3,176.3c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C96.5,172.3,98.3,174.1,98.3,176.3C98.3,176.3,98.3,176.3,98.3,176.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.1,166.2c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4c2.2,0,4,1.7,4,3.9C98.1,166.1,98.1,166.2,98.1,166.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.5,150.6c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C96.8,146.7,98.5,148.5,98.5,150.6L98.5,150.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.6,156.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9 C95.9,152.4,97.6,154.1,97.6,156.4C97.6,156.3,97.6,156.4,97.6,156.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.9,140.4c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9s1.7-4,3.9-4c0,0,0,0,0,0C96,136.4,97.8,138.1,97.9,140.4 C97.9,140.3,97.9,140.3,97.9,140.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.6,132.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9 C95.9,128.1,97.6,129.9,97.6,132.1C97.6,132.1,97.6,132.1,97.6,132.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M113.8,128c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9s1.7-4,3.9-4c0,0,0,0,0,0C111.9,124,113.7,125.8,113.8,128 C113.7,128,113.8,128,113.8,128"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M94.9,122.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C93.1,118.7,94.9,120.5,94.9,122.7 C94.9,122.7,94.9,122.7,94.9,122.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.7,220.9c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.7-3.9,3.9-4C197.9,217,199.7,218.7,199.7,220.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M200.4,273.6c0,2.2-1.7,4-3.9,4.1c-2.2,0-4-1.7-4.1-3.9c0-2.2,1.7-4,3.9-4.1c0,0,0.1,0,0.1,0 C198.6,269.7,200.4,271.5,200.4,273.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M190.1,271.5c0,2.2-1.7,4-4,4s-4-1.7-4-4c0-2.2,1.7-4,4-4c0,0,0.1,0,0.1,0 C188.3,267.5,190.1,269.3,190.1,271.5L190.1,271.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.9,263.8c0,2.2-1.7,4-3.9,4.1c-2.2,0-4-1.7-4.1-3.9c0-2.2,1.7-4,3.9-4.1c0,0,0.1,0,0.1,0 C198.2,259.9,199.9,261.6,199.9,263.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M191.5,262.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C189.7,258.2,191.5,260,191.5,262.1C191.5,262.1,191.5,262.1,191.5,262.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.7,256c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C197.9,252.1,199.7,253.8,199.7,256"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.7,247.3c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C197.9,243.4,199.7,245.2,199.7,247.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.6,251.1c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9s1.8-4,3.9-4c0,0,0,0,0,0 C187.9,247.2,189.6,249,189.6,251.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M190.1,242.9c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C188.3,238.9,190.1,240.7,190.1,242.9L190.1,242.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.5,238.5c0,2.2-1.7,4-3.9,4.1c-2.2,0-4-1.7-4.1-3.9s1.7-4,3.9-4.1c0,0,0,0,0.1,0 C197.7,234.5,199.5,236.3,199.5,238.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.5,229.5c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-3.9-1.8-3.9-3.9c0-2.2,1.8-3.9,3.9-3.9l0,0 C197.7,225.5,199.5,227.3,199.5,229.5C199.5,229.5,199.5,229.5,199.5,229.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.5,243.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9 C169.7,239.1,171.5,240.9,171.5,243.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.2,238.9c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C178.4,234.9,180.2,236.7,180.2,238.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.7,230.9c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C178.9,226.9,180.7,228.7,180.7,230.9C180.7,230.9,180.7,230.9,180.7,230.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M172.8,227.3c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9s1.8-4,3.9-4c0,0,0,0,0,0 C171,223.4,172.7,225.1,172.8,227.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161.9,204.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0 C160.2,200.7,161.9,202.5,161.9,204.7C161.9,204.7,161.9,204.7,161.9,204.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.2,211.9c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C197.5,207.9,199.2,209.7,199.2,211.9L199.2,211.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.2,194.9c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C197.5,190.9,199.2,192.7,199.2,194.9 C199.2,194.9,199.2,194.9,199.2,194.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.2,203.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0 C197.5,199.4,199.2,201.2,199.2,203.4C199.2,203.4,199.2,203.4,199.2,203.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.5,186.3c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9c0-2.2,1.7-4,3.9-4c0,0,0.1,0,0.1,0 C197.7,182.3,199.5,184.1,199.5,186.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M79.7,14.4c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-4-1.8-4-3.9s1.8-3.9,4-3.9l0,0C77.9,10.4,79.7,12.2,79.7,14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M83.7,17.2c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9c2.2,0,4,1.7,4,3.9 C83.7,17.1,83.7,17.2,83.7,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.8,9.4c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9c0-2.2,1.7-4,3.9-4c0,0,0,0,0,0C96,5.5,97.8,7.2,97.8,9.4 C97.8,9.4,97.8,9.4,97.8,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.1,4.7c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4s1.8-3.9,4-3.9c0,0,0,0,0,0C95.3,0.8,97.1,2.6,97.1,4.7 C97.1,4.7,97.1,4.8,97.1,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147.1,34.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C145.3,30.5,147.1,32.3,147.1,34.5 C147.1,34.5,147.1,34.5,147.1,34.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147.6,26.2c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9C145.8,22.2,147.6,24,147.6,26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.7,5.1c0,2.2-1.8,4-3.9,4c-2.2,0-3.9-1.8-3.9-4s1.8-4,3.9-4l0,0C151.9,1.1,153.7,2.9,153.7,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147.3,10.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9C145.5,6.2,147.3,7.9,147.3,10.1 C147.3,10.1,147.3,10.1,147.3,10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M94.7,39c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C92.9,35,94.7,36.8,94.7,39 C94.7,39,94.7,39,94.7,39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M95.3,44.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9c2.2,0,4,1.7,4,3.9 C95.3,44.4,95.3,44.4,95.3,44.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.2,57.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9C95.4,53.5,97.2,55.3,97.2,57.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.1,76.9c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9c0-2.2,1.7-3.9,3.9-4C95.3,72.9,97.1,74.7,97.1,76.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M96.9,86.3c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9C95.1,82.3,96.9,84.1,96.9,86.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.6,95.3c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9C95.9,91.3,97.6,93,97.6,95.3 C97.6,95.2,97.6,95.2,97.6,95.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.7,13.5c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0C153,9.6,154.7,11.4,154.7,13.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147.8,18.1c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9c0-2.2,1.7-3.9,3.9-4C146,14.2,147.8,15.9,147.8,18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M149.2,113.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C147.4,109.8,149.2,111.5,149.2,113.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.8,118.5c0,2.2-1.8,4-3.9,4s-3.9-1.8-3.9-3.9c0-2.2,1.8-4,3.9-4l0,0C152,114.5,153.8,116.3,153.8,118.5 C153.8,118.5,153.8,118.5,153.8,118.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M160.8,82.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0 C159.1,78.1,160.8,79.9,160.8,82.1C160.8,82.1,160.8,82.1,160.8,82.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161,94.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C159.2,90.8,161,92.5,161,94.8 C161,94.7,161,94.8,161,94.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161.2,87.9c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9s1.7-4,3.9-4c0,0,0,0,0,0C159.4,84,161.2,85.8,161.2,87.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161.4,76.1c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9c2.2,0,4,1.7,4,3.9 C161.4,76,161.4,76,161.4,76.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M162.6,69.4c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9s1.8-4,3.9-4c0,0,0,0,0,0C160.8,65.5,162.5,67.2,162.6,69.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M159.6,61.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C157.9,57.7,159.6,59.4,159.6,61.7 C159.6,61.6,159.6,61.6,159.6,61.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M155,47.1c0,2.2-1.8,4-3.9,4c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-4,3.9-4l0,0C153.2,43.1,155,44.9,155,47.1 C155,47.1,155,47.1,155,47.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.3,38.7c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9C152.6,34.7,154.3,36.4,154.3,38.7 C154.3,38.6,154.3,38.7,154.3,38.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M146.9,42.8c0,2.2-1.8,3.9-4,3.9s-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C145.2,38.8,146.9,40.6,146.9,42.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147.8,51c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9c2.2,0,4,1.7,4,3.9 C147.8,50.9,147.8,51,147.8,51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.1,55.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9 C152.4,51.5,154.1,53.3,154.1,55.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M145.7,66.7c0,2.2-1.8,3.9-3.9,3.9c-2.2,0-3.9-1.8-3.9-3.9s1.8-4,3.9-4l0,0C143.9,62.8,145.7,64.6,145.7,66.7 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M151.9,63.9c0,2.2-1.7,4-3.9,4s-4-1.7-4-3.9c0-2.2,1.7-4,3.9-4c0,0,0.1,0,0.1,0 C150.2,60,151.9,61.8,151.9,63.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M148.6,91.3c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9 C146.8,87.3,148.6,89.1,148.6,91.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M146.6,83.4c0,2.2-1.7,4-3.9,4.1s-4-1.7-4.1-3.9c0-2.2,1.7-4,3.9-4.1c0,0,0.1,0,0.1,0 C144.8,79.5,146.6,81.2,146.6,83.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M148.7,73.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9 C146.9,69.6,148.7,71.3,148.7,73.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M146.9,59c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9C145.1,55,146.9,56.8,146.9,59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.8,71.4c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C153.1,67.5,154.8,69.3,154.8,71.4C154.8,71.4,154.8,71.4,154.8,71.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M152.8,79c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C151,75,152.8,76.8,152.8,79 C152.8,79,152.8,79,152.8,79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.3,86.9c0,2.2-1.7,4-3.9,4c-2.2,0-4-1.7-4-3.9s1.7-4,3.9-4c0,0,0,0,0.1,0C151.5,83,153.3,84.8,153.3,86.9 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.1,94.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9c2.2,0,4,1.7,4,3.9 C153.1,94.7,153.1,94.8,153.1,94.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M155,102.5c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9s1.8-4,3.9-4c0,0,0,0,0,0C153.2,98.6,155,100.4,155,102.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M155,110.6c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9s1.8-4,3.9-4c0,0,0,0,0,0C153.2,106.7,155,108.4,155,110.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147.8,106.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9 C146,102.4,147.8,104.2,147.8,106.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178,76.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9c0,0,0,0,0,0 C176.3,72.9,178,74.6,178,76.8C178,76.8,178,76.8,178,76.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M173.1,64.6c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0C171.3,60.6,173.1,62.4,173.1,64.6 L173.1,64.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.3,84c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C174.5,80,176.3,81.8,176.3,84 C176.3,84,176.3,84,176.3,84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.3,60.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C174.5,56.6,176.3,58.4,176.3,60.6 C176.3,60.6,176.3,60.6,176.3,60.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M167.9,63c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0C166.1,59.1,167.9,60.8,167.9,63 L167.9,63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.3,70.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0 C168.5,66.6,170.3,68.4,170.3,70.6C170.3,70.6,170.3,70.6,170.3,70.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M169.4,78.3c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.7-3.9,3.9-3.9 C167.6,74.4,169.4,76.1,169.4,78.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M169.1,86.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C167.3,82.7,169.1,84.5,169.1,86.7 C169.1,86.7,169.1,86.7,169.1,86.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M169.1,94.5c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0 C167.3,90.5,169.1,92.3,169.1,94.5C169.1,94.5,169.1,94.5,169.1,94.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.6,102.3c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9s1.8-4,3.9-4c0,0,0,0,0,0C168.8,98.4,170.6,100.2,170.6,102.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M185.4,110.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9 C183.6,106.4,185.4,108.2,185.4,110.4C185.4,110.4,185.4,110.4,185.4,110.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.1,110.2c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9 C169.4,106.2,171.1,108,171.1,110.2C171.1,110.2,171.1,110.2,171.1,110.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M177.1,116.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0 C175.4,112.7,177.1,114.4,177.1,116.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M169.4,118.2c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9c2.2,0,4,1.7,4,3.9 C169.4,118.1,169.4,118.1,169.4,118.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M162.7,102c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C161,98,162.7,99.8,162.7,102 C162.7,102,162.7,102,162.7,102"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161.9,116.4c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9 C160.1,112.4,161.9,114.2,161.9,116.4C161.9,116.4,161.9,116.4,161.9,116.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M163.2,109.7c0,2.2-1.8,4-3.9,4s-4-1.8-4-3.9s1.8-4,3.9-4c0,0,0,0,0,0C161.5,105.8,163.2,107.6,163.2,109.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M183.5,88.3c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C181.7,84.3,183.5,86,183.5,88.3 C183.5,88.2,183.5,88.3,183.5,88.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178.7,108c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9C176.9,104,178.7,105.8,178.7,108 C178.7,108,178.7,108,178.7,108"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M184.4,118.8c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9 C182.6,114.8,184.4,116.6,184.4,118.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M185.6,102.3c0,2.2-1.8,4-3.9,4c-2.2,0-4-1.8-4-3.9c0-2.2,1.8-4,3.9-4c0,0,0,0,0,0 C183.8,98.4,185.6,100.2,185.6,102.3C185.6,102.3,185.6,102.3,185.6,102.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178.4,99.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C176.6,95.6,178.4,97.4,178.4,99.6 C178.4,99.6,178.4,99.6,178.4,99.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.8,91.9c0,2.2-1.8,4-3.9,4s-3.9-1.8-3.9-3.9c0-2.2,1.8-4,3.9-4l0,0C175,88,176.8,89.7,176.8,91.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M177.5,68.7c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,3.9-3.9c0,0,0,0,0,0 C175.7,64.8,177.5,66.5,177.5,68.7C177.5,68.7,177.5,68.7,177.5,68.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M183.3,63.6c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-3.9,4-3.9C181.6,59.6,183.3,61.3,183.3,63.6 C183.3,63.5,183.3,63.5,183.3,63.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M184.4,72c0,2.2-1.8,3.9-4,3.9c-2.2,0-3.9-1.8-3.9-4c0-2.1,1.8-3.9,3.9-3.9c2.2,0,4,1.7,4,3.9 C184.4,71.9,184.4,72,184.4,72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M95.4,72.1c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S95.4,70.5,95.4,72.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.1,190.8c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S189.1,189.1,189.1,190.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.6,323.2c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S189.6,321.6,189.6,323.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179,317.1c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S179,315.4,179,317.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M172.2,322c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S172.2,320.3,172.2,322"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M198.5,292c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S198.5,290.3,198.5,292"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M198.5,283.3c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S198.5,281.6,198.5,283.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.6,279.5c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S189.6,277.9,189.6,279.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.5,294.6c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S179.5,292.9,179.5,294.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.2,285.6c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S180.2,284,180.2,285.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180,275.5c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S180,273.9,180,275.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180,266.4c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S180,264.7,180,266.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.4,250.9c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S170.4,249.2,170.4,250.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.7,257.4c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S180.7,255.8,180.7,257.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.2,247.1c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3l0,0C178.9,244.1,180.2,245.5,180.2,247.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.6,234.9c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S189.6,233.2,189.6,234.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.8,225.5c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S189.8,223.8,189.8,225.5L189.8,225.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.1,200.3c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S189.1,198.7,189.1,200.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.5,212.8c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S179.5,211.2,179.5,212.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.2,204.1c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S180.2,202.5,180.2,204.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.2,196.4c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S180.2,194.7,180.2,196.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.7,188.6c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S179.7,187,179.7,188.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M155.9,197.2c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S155.9,195.5,155.9,197.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.4,189.5c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S153.4,187.9,153.4,189.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.5,218c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S171.5,216.3,171.5,218"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.8,207.9c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S170.8,206.3,170.8,207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.6,200.1c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S170.6,198.5,170.6,200.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.1,191.4c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S171.1,189.8,171.1,191.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.8,184.4c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S170.8,182.8,170.8,184.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199,178.8c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S199,177.1,199,178.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.2,171.5c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S199.2,169.8,199.2,171.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.3,173.8c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S171.3,172.2,171.3,173.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.1,162.6c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S171.1,160.9,171.1,162.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.7,161.9c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S180.7,160.2,180.7,161.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M198.5,151.1c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S198.5,149.4,198.5,151.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M199.2,144c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S199.2,142.3,199.2,144"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.4,156.9c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S189.4,155.3,189.4,156.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.7,154.1c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S179.7,152.5,179.7,154.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.1,142.7c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S180.1,141,180.1,142.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M94.7,61.3c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3l0,0C93.4,58.3,94.7,59.7,94.7,61.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M96.8,32c0,1.7-1.3,3-3,3s-3-1.3-3-3c0-1.7,1.3-3,3-3S96.8,30.3,96.8,32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M96.4,23.3c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S96.4,21.6,96.4,23.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik9);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_9.bcaea015efda25f7286d5b5ab6892307.svg";
export { ForwardRef as ReactComponent };